import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import Close from 'icons/button_close.svg'

export const Wrap = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: ${calculateResponsiveSize(20)};
    left: ${calculateResponsiveSize(122)};
    right: ${calculateResponsiveSize(122)};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${calculateResponsiveSize(20)};
    padding: ${calculateResponsiveSize(18)} ${calculateResponsiveSize(20)};
    font-size: ${calculateResponsiveSize(14)};
    color: #ffffff;
    line-height: 1.4;
    border-radius: 12px;
    background: rgba(32, 33, 36, 0.8);
    opacity: 0;
    visibility: hidden;
    transition: opacity 1s;
    z-index: 49;
  }
  &.show {
    .cookies-banner {
      opacity: 1;
      visibility: visible;
    }
  }
  .cookies-banner-accept-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${calculateResponsiveSize(76)};
    height: ${calculateResponsiveSize(25)};
    font-size: ${calculateResponsiveSize(10)};
    color: #ffffff;
    font-weight: 600;
    letter-spacing: ${calculateResponsiveSize(1)};
    text-transform: uppercase;
    border-radius: 6px;
    border: 1px solid #ffffff;
    background: transparent;
    transition: color 0.25s, border 0.25s, background 0.25s;
    position: relative;
    cursor: pointer;
    &:hover {
      color: #000000;
      background: #ffffff;
    }
  }
  ${mediaMax('mobile')} {
    .cookies-banner {
      bottom: 0;
      left: 0;
      right: 0;
      gap: ${calculateMobileResponsiveSize(10)};
      padding: ${calculateMobileResponsiveSize(15)} ${calculateMobileResponsiveSize(20)};
      font-size: ${calculateMobileResponsiveSize(14)};
      border-radius: 0;
    }
    .cookies-banner-accept-btn {
      width: ${calculateMobileResponsiveSize(65)};
      height: ${calculateMobileResponsiveSize(20)};
      font-size: ${calculateMobileResponsiveSize(9)};
      letter-spacing: ${calculateMobileResponsiveSize(0.9)};
    }
  }
`

export const Content = styled.div``

export const LinkItem = styled.a`
  text-decoration: underline;
  color: #ffffff;
  &:hover {
    text-decoration: none;
  }
`

export const ButtonClose = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(15)};
  width: ${calculateResponsiveSize(26)};
  height: ${calculateResponsiveSize(26)};
  transform: translateY(-50%);
  background: url(${Close}) center center no-repeat;
  background-size: ${calculateResponsiveSize(24)};
  transition: background-size 0.25s;
  cursor: pointer;
  &:hover {
    background-size: ${calculateResponsiveSize(26)};
  }
  ${mediaMax('mobile')} {
    right: ${calculateMobileResponsiveSize(15)};
    width: ${calculateMobileResponsiveSize(20)};
    height: ${calculateMobileResponsiveSize(20)};
    background-size: ${calculateMobileResponsiveSize(18)};
    &:hover {
      background-size: ${calculateMobileResponsiveSize(20)};
    }
  }
`
